import React from "react";
import RezervacijeDan from "../Moduli/RezervacijeDan";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import * as Colors from "material-ui/styles/colors";

const muiTheme = getMuiTheme({
  palette: {
    textColor: Colors.darkBlack,
    primary1Color: Colors.lightGreen600,
    primary2Color: Colors.indigo700,
    accent1Color: Colors.lightGreen600,
    pickerHeaderColor: Colors.darkBlack,
    alternateTextColor: Colors.white
  },
  appBar: {
    height: 45
  }
});

export default class Rezervacije extends React.Component {

  render() {
    let rezDan = []
     for (let i = 0; i < 7; i++) {
     
       var rezDanData = this.props.rezervacije.filter(function (el) {
         return el.dan === i});
       if(rezDanData.length > 0){
       rezDan.push(<RezervacijeDan key={i} rezervacije={rezDanData}/>);
     }
     }
    return (

        <MuiThemeProvider muiTheme={muiTheme}>
        <div style={{flexDirection: 'row',display: "flex",flexWrap:'wrap'}}>
        {rezDan}</div>
        </MuiThemeProvider>
   
    );
  }
}



// WEBPACK FOOTER //
// ./src/Izvestaji/Rezervacije.js